/* tempexp_18086-start */
import { Icon16CopyOutline, Icon20ErrorCircleOutline } from '@vkontakte/icons';
import { Text } from '@vkontakte/vkui';
import classNames from 'clsx';
import React from 'react';
import { referralProgramBonusQuota } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { Button } from 'reactApp/ui/Button/Button';
import { useReferralLink } from 'reactApp/ui/ReferralProgram/ReferralModal/hooks/useReferralLink';
import { getPeriodName } from 'reactApp/utils/Period';

import styles from './BonusExpiresWarning.css';

interface BonusExpiresWarningProps {
    isMobile?: boolean;
    expiredDays: number;
    email: string;
}

export function BonusExpiresWarning({ expiredDays, isMobile, email }: BonusExpiresWarningProps) {
    const { copyOrShare, buttonText, disabled } = useReferralLink(email);
    return (
        <div className={classNames(styles.root, { [styles.rootMobile]: isMobile })}>
            <div className={styles.info}>
                <Icon20ErrorCircleOutline className={styles.error_icon} />
                <Text className={styles.text}>
                    Бонус сгорит через <span className={styles.bold}>{getPeriodName(`${expiredDays}d`)}</span>&nbsp;— подписка друга больше
                    не&nbsp;активна. Отправьте ссылку другому {isMobile ? `и сохраните ${referralProgramBonusQuota.value}` : ''}
                </Text>
            </div>
            <Button theme="vk" disabled={disabled} secondary fluid onClick={copyOrShare}>
                {isMobile ? (
                    'Отправить ссылку'
                ) : (
                    <>
                        <Icon16CopyOutline />
                        {buttonText}
                    </>
                )}
            </Button>
        </div>
    );
}

/* tempexp_18086-end */
